import {
  IonPage,
  IonContent,
  IonText,
  IonGrid,
  IonRow,
  IonCol,
  IonCard,
  IonCardContent,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonRouterLink,
  IonImg,
} from '@ionic/react'

import logo from '../resources/OneShop_Logo_White.png'
import { useQueryParams } from '../hooks/use-query-params'
import { CreateAccountForm } from '../auth/components/create-account-form'

function CreateAccountPage() {
  const shopParam = useQueryParams().get('shop')

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonTitle>
            <h2>Sign Up</h2>
          </IonTitle>
        </IonToolbar>
      </IonHeader>

      <IonContent>
        <IonGrid className="h-full">
          <IonRow className="h-full items-center justify-center">
            <IonCol size="12">
              <IonImg src={logo} alt="Oneshop Logo" className="h-16" />

              {shopParam ? (
                <IonText>
                  Create your OneShop account to connect to Shopify
                </IonText>
              ) : null}
              <div className="mx-auto max-w-lg">
                <IonCard color="secondary">
                  <IonCardContent>
                    <CreateAccountForm />
                  </IonCardContent>
                </IonCard>
              </div>

              <div className="ion-text-center">
                Already have an account, please{' '}
                <IonRouterLink
                  style={{ color: 'white', textDecoration: 'underline' }}
                  routerLink={
                    '/login' +
                    (shopParam && shopParam !== 'null'
                      ? `?shop=${shopParam}`
                      : '')
                  }
                  routerDirection="none"
                >
                  login
                </IonRouterLink>
                .
              </div>
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonContent>
    </IonPage>
  )
}

export default CreateAccountPage
